import { takeLatest } from 'redux-saga/effects';
import {
  GET_DESTINATION_DISTANCE,
  GET_GARAGE_ORIENTATION,
  SEND_SELECTED_DESTINATION,
} from 'redux/actions/types';
import {
  getDestinationDistanceSaga,
  getGarageOrientationSaga,
  sendSelectedDestinationSaga,
} from './destination-saga';

export default function* destinationSagas() {
  yield takeLatest(GET_GARAGE_ORIENTATION, getGarageOrientationSaga);
  yield takeLatest(SEND_SELECTED_DESTINATION, sendSelectedDestinationSaga);
  yield takeLatest(GET_DESTINATION_DISTANCE, getDestinationDistanceSaga);
}
